import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Pages
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import CityPage from "./pages/CityPage";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import ZonesIntervention from "./pages/ZonesIntervention";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Home */}
          <Route path="/" element={<Home />} />

          {/* Services */}
          <Route path="/service/:slug" element={<ServicePage />} />

          {/* Cities - using full path pattern */}
          <Route path="/serrurier/:citySlug" element={<CityPage />} />
          <Route path="/zones-intervention" element={<ZonesIntervention />} />

          {/* Blog */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />

          {/* Contact */}
          <Route path="/contact" element={<Contact />} />

          {/* Fallback to Home */}
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
